import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import AboutUsDetailed from "./pages/AboutUsDetailed";
import OmOss from "./pages/OmOss";
import BlogStory from "./pages/BlogStory";
import PreWorkout from "./pages/products/PreWorkout";
import PreWorkoutMaxed from "./pages/products/PreWorkoutMaxed";
import ShakerPage from "./pages/products/Shaker";
import ChalkPage from "./pages/products/Chalk";
import TennisSocks from "./pages/products/TennisSocks";
import PaymentSuccess from "./pages/PaymentSuccess";
import NotFound from "./pages/NotFound";
import AdminDiscounts from "./pages/AdminDiscounts";
import Contact from "./pages/Contact";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUsDetailed />} />
              <Route path="/om-oss" element={<OmOss />} />
              <Route path="/blog/vaar-historie" element={<BlogStory />} />
              <Route path="/products/pre-workout" element={<PreWorkout />} />
              <Route path="/products/pre-workout-maxed" element={<PreWorkoutMaxed />} />
              <Route path="/products/shaker" element={<ShakerPage />} />
              <Route path="/products/chalk" element={<ChalkPage />} />
              <Route path="/products/tennis-socks" element={<TennisSocks />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/admin/discounts" element={<AdminDiscounts />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
